import angular from 'angular';
import ComponentsModule from '../components-module';

const COMPONENT_NAME = 'routeIndicator';

angular.module (ComponentsModule)
  .directive (COMPONENT_NAME, function ($rootScope) {
    return {
      scope: {},
      replace: false,

      template: '<div x-ng-if="routeIsLoading" x-spinner x-radius="6" x-width="3" x-length="6" class="route-indicator"></div>',

      link: function (scope) {
        scope.routeIsLoading = true;

        $rootScope.$on('$routeChangeStart', function () {
          scope.routeIsLoading = true;
        });

        $rootScope.$on('$routeChangeSuccess', function () {
          scope.routeIsLoading = false;
        });

        $rootScope.$on('$routeChangeError', function () {
          scope.routeIsLoading = false;
        });
      }
    };
  });

export default COMPONENT_NAME;
